import { OChainId } from 'modules/api';
import { default as baseIcon } from 'modules/common/assets/base-network.svg';
import { ISpriteIconProps, SpriteIcon } from '../SpriteIcon';
import { default as bscIcon } from './assets/bsc.svg';
import { default as ethIcon } from './assets/ethereum.svg';
import { default as berachainIcon } from './assets/berachain.svg';
import { default as sonicIcon } from './assets/sonic.svg';

interface INetworkIconProps extends Omit<ISpriteIconProps, 'src'> {
  chainId?: number;
}

export function NetworkIcon({
  chainId,
  ...restProps
}: INetworkIconProps): JSX.Element {
  const svgIconId = getNetworkIcon(chainId);

  return <SpriteIcon {...restProps} src={svgIconId} />;
}

// todo: add icons according to the TChainId
function getNetworkIcon(chainId?: number): string {
  switch (chainId) {
    case OChainId.binanceSmartChain:
    case OChainId.binanceSmartChainTestnet: {
      return bscIcon;
    }

    case OChainId.base:
    case OChainId.baseSepoliaTestnet: {
      return baseIcon;
    }

    case OChainId.berachainBartioTestnet: {
      return berachainIcon;
    }

    case OChainId.sonic: {
      return sonicIcon;
    }

    case OChainId.ethereum:
    case OChainId.holesky:
    case OChainId.sepolia:
    default:
      return ethIcon;
  }
}
